import { Platform } from '@angular/cdk/platform';
import { NativeDateAdapter } from '@angular/material';
import { MatDateFormats } from '@angular/material/core';
import * as moment from 'moment';

export class AppDateAdapter extends NativeDateAdapter {

    private momentLocaleData = moment.localeData('es-Es');
    private selectedCustomLocale;
    constructor(matDateLocale: string) {
        super(matDateLocale, new Platform());
        this.momentLocaleData = moment.localeData(matDateLocale);
        this.selectedCustomLocale = matDateLocale;
    }

    format(date: Date, displayFormat: Object): string {

        if (displayFormat === 'input') {
            let day: string = date.getDate().toString();
            day = +day < 10 ? '0' + day : day;
            let month: string = (date.getMonth() + 1).toString();
            month = +month < 10 ? '0' + month : month;
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }

        const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleDateString(this.selectedCustomLocale, options);
    }

    getFirstDayOfWeek(): number {
        return 1;
    }

    getMonthNames() {
        return this.momentLocaleData.monthsShort()
    }

    getDayOfWeekNames() {
        return this.momentLocaleData.weekdaysShort()
    }

    getDayOfWeek() {
        return this.momentLocaleData.firstDayOfWeek();
    }


    setLocale() {
        super.setLocale('es-Es')
    }



}
export const APP_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
    },
    display: {
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'numeric' },
        dateA11yLabel: {
            year: 'numeric', month: 'long', day: 'numeric'
        },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    }
};

